module.exports = __webpack_public_path__ + "static/media/worry-free-6.9747d860.png";